module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/rings/diamond-cocktail-6a2270fc0310492333bcf729880d6613.webp";